import { PdChatInput } from "./PdChatInput.js";
//#region src/pd-chat/pd-chat-input.ts
var tag = "pd-chat-input";
if (!customElements.get(tag)) customElements.define(tag, PdChatInput);
//#endregion
export { PdChatInput };
